import { type ComponentProps } from 'react';

import { Plus } from '@air/next-icons';
import { IconButton } from '@air/primitive-icon-button';

export type BoardSelectListHeaderProps = ComponentProps<'h2'> & {
  onCreate?: () => void;
};

export const BoardSelectListHeader = ({ children, onCreate }: BoardSelectListHeaderProps) => {
  return (
    <h2 className="flex h-6 shrink-0 items-center justify-between gap-2 px-2 font-bold text-12 text-grey-9 uppercase tracking-wider">
      {children}

      {!!onCreate && (
        <IconButton appearance="ghost" color="grey" icon={Plus} label="Create new" onClick={onCreate} size="small" />
      )}
    </h2>
  );
};
